import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { CrossIcon } from '@pleio/icons/cross'
import { HistoryIcon } from '@pleio/icons/history'

import IconButton from 'js/components/IconButton'
import Popover from 'js/components/Popover'
import PageEditorContext from 'js/page/PageEditor/PageEditorContext'

import styles from './PageEditorRevisions.module.css'
import type { PageEditorRevisionsProps } from './PageEditorRevisions.types'
import PageEditorRevisionsList from './PageEditorRevisionsList'

const PageEditorRevisions = ({ disabled }: PageEditorRevisionsProps) => {
    const { t } = useTranslation()

    const {
        pageRevisions: {
            revisionsPopoverOpen,
            setRevisionsPopoverOpen,
            revisionTotal,
        },
    } = useContext(PageEditorContext)

    if (revisionTotal === 0) {
        return null
    }

    return (
        <div>
            <Popover
                open={revisionsPopoverOpen}
                setOpen={setRevisionsPopoverOpen}
                trigger="toggle"
                content={
                    <div className={styles.popoverContent}>
                        <div className={styles.popoverHeader}>
                            <div className={styles.popoverTitle}>
                                {t('version.version-history')}
                            </div>
                            <IconButton
                                size="normal"
                                variant="secondary"
                                radiusStyle="rounded"
                                tooltip={t('action.close')}
                                onClick={() => setRevisionsPopoverOpen(false)}
                                className={styles.popoverCloseButton}
                            >
                                <CrossIcon />
                            </IconButton>
                        </div>
                        <PageEditorRevisionsList />
                    </div>
                }
                side="bottom"
                align="end"
                sideIsForced={true}
                positionIsFixed={true}
                hideArrow={true}
                alignOffset={-8}
            >
                <IconButton
                    size="large"
                    variant="secondary"
                    radiusStyle="rounded"
                    tooltip={t('version.version-history')}
                    disabled={disabled}
                    data-testid="button-history"
                >
                    <HistoryIcon />
                </IconButton>
            </Popover>
        </div>
    )
}

export default PageEditorRevisions
